// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
@layer properties;
.top-menu {
  .navbar {
    display: flex;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 3px;
    border-bottom-color: var(--color-red-700, oklch(50.5% 0.213 27.518));
  }
  .dropdown-item.submenu-container, .dropdown {
    position: relative;
    a {
      .caret {
        margin-left: auto;
      }
    }
    > .dropdown-menu {
      position: absolute;
      display: block;
      min-width: 180px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1);
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 10000;
    }
    &:hover > .dropdown-menu, &:focus > .dropdown-menu {
      opacity: 1;
      visibility: visible;
      transform: translateX(0) translateY(0px);
    }
  }
  .dropdown {
    > .dropdown-menu {
      top: 100%;
      left: 0;
      transform: translateY(-10px);
    }
  }
  .dropdown-item.submenu-container {
    > .dropdown-menu {
      top: 0;
      left: 100%;
      transform: translateX(-10px);
    }
  }
  .nav.navbar-nav {
    margin: 7px auto auto;
  }
  .nav.navbar-nav.navbar-right {
    display: flex;
    align-items: center;
  }
  .dropdown {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    @media (width >= 64rem) {
      width: max-content;
    }
    @media (width >= 64rem) {
      justify-content: center;
    }
    > .dropdown-toggle {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: calc(var(--spacing, 0.25rem) * 2);
      font-size: var(--text-base, 1rem);
      line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
      color: var(--color-white, #fff);
    }
    > .dropdown-menu {
      margin-top: calc(var(--spacing, 0.25rem) * 0);
      a {
        color: var(--color-gray-900, oklch(21% 0.034 264.665));
      }
    }
  }
  .dropdown {
    cursor: pointer;
  }
  .dropdown-menu a {
    display: block;
    padding: 3px 10px;
    &:focus, &:hover {
      background-color: #ddd;
    }
  }
  .dropdown-submenu {
    position: relative;
  }
  .dropdown-submenu > .dropdown-menu {
    top: 0;
    left: 100%;
    margin-top: -6px;
    margin-left: -1px;
    -webkit-border-radius: 0 6px 6px 6px;
    -moz-border-radius: 0 6px 6px 6px;
    border-radius: 0 6px 6px 6px;
  }
  .dropdown-submenu:hover > .dropdown-menu {
    display: block;
  }
  .dropdown-submenu > a:after {
    display: block;
    content: " ";
    float: right;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 5px 0 5px 5px;
    border-left-color: #cccccc;
    margin-top: 5px;
    margin-right: -10px;
  }
  .dropdown-submenu:hover > a:after {
    border-left-color: #ffffff;
  }
  .dropdown-submenu.pull-left {
    float: none;
  }
  .dropdown-submenu.pull-left > .dropdown-menu {
    left: -100%;
    margin-left: 10px;
    -webkit-border-radius: 6px 0 6px 6px;
    -moz-border-radius: 6px 0 6px 6px;
    border-radius: 6px 0 6px 6px;
  }
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
    }
  }
}`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/TopMenu/topMenu.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACIoB,iBAAU;AAF9B;EACI;IACW,aAAI;IAAC,2CAAU;IAAV,wBAAU;IAAC,oEAAgB;EAC1C;EAED;IACI,kBAAmB;IAEnB;MACI;QACI,iBAAkB;MACrB;IACJ;IAED;MACI,kBAAmB;MACnB,cAAe;MACf,gBAAiB;MACjB,iBAAkB;MAClB,kBAAmB;MACnB,+CAAgD;MAChD,UAAW;MACX,kBAAmB;MACnB,yBAA0B;MAC1B,cAAe;IAClB;IAED;MACI,UAAW;MACX,mBAAoB;MACpB,wCAAyC;IAC5C;EACJ;EAED;IACI;MACI,SAAU;MACV,OAAQ;MACR,4BAA6B;IAChC;EACJ;EAED;IACI;MACI,MAAO;MACP,UAAW;MACX,4BAA6B;IAChC;EACJ;EAGD;IACI,qBAAsB;EACzB;EAED;IACI,aAAc;IACd,mBAAoB;EACvB;EAED;IACW,aAAI;IAAgD,YAAM;IAAtB,WAAM;IAArC,mBAAY;IAA0B;MAAA,kBAAQ;IAAA;IAAjC;MAAA,uBAAiB;IAAA;IAE1C;MACW,aAAI;MAAyC,mBAAQ;MAAhD,mBAAY;MAAsB,sCAAK;MAAf,iCAAS;MAAT,4EAAS;MAApB,+BAAU;IACtC;IAED;MACW,6CAAI;MAEX;QACW,sDAAa;MACvB;IACJ;EACJ;EAED;IACI,eAAgB;EACnB;EAED;IACW,cAAK;IAAC,iBAAY;IAEzB;MACI,sBAAuB;IAC1B;EACJ;EAED;IACI,kBAAmB;EACtB;EAED;IACI,MAAO;IACP,UAAW;IACX,gBAAiB;IACjB,iBAAkB;IAClB,oCAAqC;IACrC,iCAAkC;IAClC,4BAA6B;EAChC;EAED;IACI,cAAe;EAClB;EAED;IACI,cAAe;IACf,YAAa;IACb,YAAa;IACb,QAAS;IACT,SAAU;IACV,yBAA0B;IAC1B,mBAAoB;IACpB,2BAA4B;IAC5B,0BAA2B;IAC3B,eAAgB;IAChB,mBAAoB;EACvB;EAED;IACI,0BAA2B;EAC9B;EAED;IACI,WAAY;EACf;EAED;IACI,WAAY;IACZ,iBAAkB;IAClB,oCAAqC;IACrC,iCAAkC;IAClC,4BAA6B;EAChC;AAEJ;AAtImB;EAAA,WAAU;EAAV,eAAU;EAAV,oBAAU;AAAA;AAAV;EAAA;IAAA;MAAA,wBAAU;IAAA;EAAA;AAAA","sourcesContent":[null,"@reference \"../../assets/css/main.css\";\r\n\r\n.top-menu {\r\n    .navbar {\r\n        @apply flex border-b-3 border-b-red-700;\r\n    }\r\n\r\n    .dropdown-item.submenu-container, .dropdown {\r\n        position: relative;\r\n\r\n        a {\r\n            .caret {\r\n                margin-left: auto;\r\n            }\r\n        }\r\n\r\n        > .dropdown-menu {\r\n            position: absolute;\r\n            display: block;\r\n            min-width: 180px;\r\n            background: white;\r\n            border-radius: 8px;\r\n            box-shadow: 0 10px 25px -3px rgba(0, 0, 0, 0.1);\r\n            opacity: 0;\r\n            visibility: hidden;\r\n            transition: all 0.3s ease;\r\n            z-index: 10000;\r\n        }\r\n\r\n        &:hover > .dropdown-menu, &:focus > .dropdown-menu {\r\n            opacity: 1;\r\n            visibility: visible;\r\n            transform: translateX(0) translateY(0px);\r\n        }\r\n    }\r\n\r\n    .dropdown {\r\n        > .dropdown-menu {\r\n            top: 100%;\r\n            left: 0;\r\n            transform: translateY(-10px);\r\n        }\r\n    }\r\n\r\n    .dropdown-item.submenu-container {\r\n        > .dropdown-menu {\r\n            top: 0;\r\n            left: 100%;\r\n            transform: translateX(-10px);\r\n        }\r\n    }\r\n\r\n\r\n    .nav.navbar-nav {\r\n        margin: 7px auto auto;\r\n    }\r\n\r\n    .nav.navbar-nav.navbar-right {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .dropdown {\r\n        @apply flex items-center lg:justify-center w-full lg:w-max h-full;\r\n\r\n        > .dropdown-toggle {\r\n            @apply flex items-center text-white text-base gap-2 flex-row;\r\n        }\r\n\r\n        > .dropdown-menu {\r\n            @apply mt-0;\r\n\r\n            a {\r\n                @apply text-gray-900;\r\n            }\r\n        }\r\n    }\r\n\r\n    .dropdown {\r\n        cursor: pointer;\r\n    }\r\n\r\n    .dropdown-menu a {\r\n        @apply block p-[3px_10px];\r\n\r\n        &:focus, &:hover {\r\n            background-color: #ddd;\r\n        }\r\n    }\r\n\r\n    .dropdown-submenu {\r\n        position: relative;\r\n    }\r\n\r\n    .dropdown-submenu > .dropdown-menu {\r\n        top: 0;\r\n        left: 100%;\r\n        margin-top: -6px;\r\n        margin-left: -1px;\r\n        -webkit-border-radius: 0 6px 6px 6px;\r\n        -moz-border-radius: 0 6px 6px 6px;\r\n        border-radius: 0 6px 6px 6px;\r\n    }\r\n\r\n    .dropdown-submenu:hover > .dropdown-menu {\r\n        display: block;\r\n    }\r\n\r\n    .dropdown-submenu > a:after {\r\n        display: block;\r\n        content: \" \";\r\n        float: right;\r\n        width: 0;\r\n        height: 0;\r\n        border-color: transparent;\r\n        border-style: solid;\r\n        border-width: 5px 0 5px 5px;\r\n        border-left-color: #cccccc;\r\n        margin-top: 5px;\r\n        margin-right: -10px;\r\n    }\r\n\r\n    .dropdown-submenu:hover > a:after {\r\n        border-left-color: #ffffff;\r\n    }\r\n\r\n    .dropdown-submenu.pull-left {\r\n        float: none;\r\n    }\r\n\r\n    .dropdown-submenu.pull-left > .dropdown-menu {\r\n        left: -100%;\r\n        margin-left: 10px;\r\n        -webkit-border-radius: 6px 0 6px 6px;\r\n        -moz-border-radius: 6px 0 6px 6px;\r\n        border-radius: 6px 0 6px 6px;\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
